<template>
  <div class="menubar-team">
    <div class="menubar-heading">My Team
      <font-awesome-icon
        @click="onClickChevron"
        icon="chevron-down"
        :class="{
          'is-active': collapsed
        }" />
    </div>

    <!-- v-if="$ready_contacts" -->
    <transition name="fade">
      <div v-if="!collapsed">

        <SidebarContact
          v-for="contact in contacts_sorted"
          :key="contact.$key"
          :contact-id="contact.contactUserId" />

        <template v-if="userHasNoContacts">
          <div
            v-for="n in 3"
            :key="'dummy-'+n"
            :style="{ order: n }"
            class="sidebar-contact sidebar-contact--dummy">
            <div class="sidebar-contact__avatar"><span class="avatar"></span></div>
            <div class="sidebar-contact__text"></div>
          </div>
        </template>

        <div @click="onInviteUser" class="menu-add-button clickable">
          <font-awesome-icon :icon="['far', 'plus-circle']" />
          <div class="menu-add-button__text">Invite to Goalpilot</div>
        </div>

        <OutgoingInvitations />

        <template v-if="userHasNoContacts">
          <div class="menu-no-content">
            <p>
              Don't do everything alone.<br />
              Add others to your projects to get work done faster.
            </p>
          </div>
        </template>

      </div>
    </transition>

    <!--
    <div class="w-100 px-1 my-2">
      <MessageMenu />
    </div>
    -->
  </div>
</template>

<script>
import SidebarContact from '@/layouts/Elements/SidebarContact'
import OutgoingInvitations from '@/layouts/Elements/OutgoingInvitations'
import InvitePromptMixin from '@/components/Mixins/Prompts/InvitePrompt'
// import MessageMenu from '@/layouts/Elements/MessageMenu'

export default {
  mixins: [ InvitePromptMixin ],
  data: () => ({
    collapsed: false,
    invite_dialog_visible: false,
  }),
  computed: {
     contacts_sorted() {
      // return []; // < testing
      return this.userContacts.itemsAsArray();
    },

    userContacts() {
      // TODO: Show other user as pending, when not confirmed
      return this.$models.userContact.subscribeList();
    },

    userHasNoContacts() {
      return this.contacts_sorted.length === 0;
    }
  },
  methods: {
    onClickChevron() {
      this.collapsed = !this.collapsed;
    },

    onInviteUser() {
      this.$invite_prompt({
        type: 'Goalpilot'
      })
    },
  },
  components: {
    OutgoingInvitations,
    // MessageMenu,
    SidebarContact,
  }
};
</script>

<style>
/*
.user-contact-list {
  overflow-y: auto;
  max-height: calc(100vw - 150px);
}
.user-contact-list .contact-bar-button {
  height: 50px;
  width: 80px;
  border-radius: 0;
  position: absolute;
  background: #363230;
  border: none;
  color: white;
}
*/
</style>
